module.exports = __webpack_public_path__ + "img/undraw_Images_re_0kll.6e080eff.svg";